module.exports = __webpack_public_path__ + "static/Eliza2-995f8737dfadf140ee4a85ad8733ff7a.webp";